import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CalendarApp from './pages/CalendarApp';
import AdminUsage from './pages/AdminUsage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CalendarApp />} />
        <Route path="/admin" element={<AdminUsage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
